import type { ReactNode } from "react";

interface ChallengeTimerProps {
  totalMs: number;
  remainingMs: number;
}

export function ChallengeTimer({ totalMs, remainingMs }: ChallengeTimerProps): ReactNode {
  const pct = Math.max(0, Math.min(1, remainingMs / totalMs));
  const color =
    pct > 0.5 ? "#22c55e" :
    pct > 0.25 ? "#f59e0b" : "#ef4444";
  const secs = Math.ceil(remainingMs / 1000);

  return (
    <div className="mb-4" aria-live="off">
      <div
        className="w-full h-1.5 bg-ink/10"
        role="timer"
        aria-label={`${secs}s remaining`}
      >
        <div
          className="h-full"
          style={{
            width: `${pct * 100}%`,
            background: color,
            transition: "width 100ms linear",
          }}
        />
      </div>
      <p className="font-mono text-[10px] text-inkFaded mt-0.5 text-right tabular-nums">
        {secs}s
      </p>
    </div>
  );
}
